import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './SearchResult.css'
import { FaCalendarAlt, FaEye } from 'react-icons/fa';
import Loader from '../Component/Loader';

export default function SearchResults() {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [notFound, setNotFound] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const location = useLocation();
  const navigate = useNavigate();

  const query = new URLSearchParams(location.search).get('q');

  const fetchResults = async (searchQuery) => {
    if (!searchQuery) return;

    setLoading(true);
    setNotFound(false);

    try {
      const options = {
        headers: {
          Accept: 'application/json',
          'Client-Domain': process.env.REACT_APP_CLIENT_DOMAIN,
        },
      };

      const res = await axios.post(
      `${process.env.REACT_APP_BASE_URL}website/search`,
        { search: searchQuery },
        options
      );

      const blogs = res.data?.blogs || [];
      setResults(blogs);
      if (blogs.length === 0) setNotFound(true);
    } catch (err) {
      console.error("Search error:", err);
      setNotFound(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (query) {
      setSearchTerm('');
      fetchResults(query);
    }
  }, [query]);

  const closeSidebarAndModal = () => {
    const offcanvasElement = document.getElementById('offcanvasWithBothOptions');
    if (offcanvasElement && window.bootstrap?.Offcanvas) {
      const offcanvas = window.bootstrap.Offcanvas.getOrCreateInstance(offcanvasElement);
      offcanvas.hide();
    }

    const backdrop = document.querySelector('.offcanvas-backdrop');
    if (backdrop) backdrop.remove();

    document.body.classList.remove('offcanvas-open', 'modal-open', 'overflow-hidden');
  };

  const handleNewSearch = () => {
    if (!searchTerm.trim()) return;
    closeSidebarAndModal();
    navigate(`/search?q=${encodeURIComponent(searchTerm.trim())}`);
  };

  const highlightKeyword = (text) => {
    if (!query || !text) return text;
    const regex = new RegExp(`(${query})`, 'gi');
    return text.replace(regex, '<mark>$1</mark>');
  };

  const truncateText = (text, maxLength) => {
    if (!text) return '';
    return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
  };

  return (
    <div className="search-results-wrapper">
      <div className="search-results-page">
        <div className="search-inline-box">
          <input
            type="text"
            placeholder="Type and hit enter..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleNewSearch()}
          />
          <button onClick={handleNewSearch}>Search</button>
        </div>

        <h2 className="results-heading">Search Results for "{query}"</h2>

        {loading && <Loader text="Searching..." />}


        {!loading && notFound && <p>No results found.</p>}

        {!loading && !notFound && results.length > 0 && (
          <div className="card-grid">
            {results.map(blog => (
              <div key={blog.id} className="card">
                {blog.image_400x300 && (
                  <img
                    src={`https://api.funfillia.com/${blog.image_400x300}`}
                    alt={blog.title}
                    className="card-image"
                  />
                )}
                <div className="card-content">
                  <h3 className="card-title">{blog.title}</h3>
                  <p
                    className="card-description"
                    dangerouslySetInnerHTML={{
                      __html: highlightKeyword(truncateText(blog.short_description, 100))
                    }}
                  />
                  <div className="card-meta">
                    <span><FaCalendarAlt/> {new Date(blog.published_at).toLocaleDateString()}</span>
                    {blog.category?.name && <span> | 🏷️ {blog.category.name}</span>}
                    <span> <FaEye/> {blog.views_count} views</span>
                  </div>
                  <button
                    onClick={() => {
                      closeSidebarAndModal();
                      navigate(`/blog/${blog.slug}`);
                    }}
                    className="card-button"
                  >
                    Read More
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
